export const validateUserCount = ({
  ceiling,
  plan,
  maxNumberOfUsersForOrderEstimate,
}: {
  ceiling?: number;
  plan: string;
  maxNumberOfUsersForOrderEstimate?: number | undefined | null;
}) => {
  return (value: unknown) => {
    if (!ceiling) return undefined;
    const maxPermissibleUsers = maxNumberOfUsersForOrderEstimate
      ? Math.min(ceiling, maxNumberOfUsersForOrderEstimate)
      : ceiling;
    const errorMessage =
      maxPermissibleUsers < ceiling
        ? `${maxPermissibleUsers.toLocaleString()} is the max limit for price estimation`
        : `${ceiling.toLocaleString()} users is the max for the ${plan} plan`;
    if (value && Number(value) > maxPermissibleUsers) {
      return errorMessage;
    }
    return undefined;
  };
};
